import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SubcontractPage } from '@/features/subcontracts/contract-page';

const searchSchema = z.object({
  tab: z
    .enum(['agreement', 'progress', 'mobilisation', 'final-account', 'performance', 'closeout'])
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute(
  '/_app/projects/$projectId/subcontracts/contracts/$subcontractId',
)({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId, subcontractId } = Route.useParams();
  const { tab } = Route.useSearch();
  return <SubcontractPage projectId={projectId} subcontractId={subcontractId} tab={tab} />;
}
